import { Box } from '@mui/material';
import React from 'react';

export const NewsBackground = React.memo(() => (
  <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url('/assets/freemium-background.svg')`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      zIndex: -1,
      pointerEvents: 'none',
      isolation: 'isolate',
      contain: 'layout style paint',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(
            to bottom,
            transparent 0%,
            transparent 20%,
            rgba(29, 31, 40, 0.2) 30%,
            rgba(29, 31, 40, 0.5) 40%,
            rgba(29, 31, 40, 0.8) 50%,
            rgba(29, 31, 40, 0.95) 60%,
            #1D1F28 100%
          )`,
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(
            to right,
            rgba(29, 31, 40, 0.3) 0%,
            transparent 8%,
            transparent 92%,
            rgba(29, 31, 40, 0.3) 100%
          )`,
      }}
    />
  </Box>
));
